import EstadoDeudaCrud from './EstadoDeudaCrud'
export {EstadoDeudaCrud}
export default EstadoDeudaCrud
